<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user :campaign-id="campaignId" :user-status="user_status" @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout" @show-confirmation="showConfirmation" @current-user="handleCurrentUser"
          custom-css="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/custom_overrides.css"
          :language="$t('Language')"></snipp-current-user>
      </div>

      <div id="registration-wrapper" v-if="registration_enabled">       
        <snipp-registration app-source="CampaignWidget" refresh-reload="true" :campaign-id="campaignId"
         :key="`registration-${$t('Language')}`"
          :show-confirmation="show_confirmation"
          custom-css="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/custom_overrides.css"
          :is-logged-out="is_logged_out" @is-registered="handleIsRegistered"
          :language="$t('Language')"></snipp-registration>
      </div>

      <div id="thanks-text" v-if="upload_enabled === 'upload_again'">
        <div class="text-block text-center position-relative">
          <h1 class="page-heading" v-html="$t('IPEwidget.ThanksTitle')"></h1>
        </div>
        <section class="submission-msg text-center">
          <div class="submission-msg_subheader">
            <p class="page-subheader"><span class="submission-msg_subheader_icon"><i class="fa-regular fa-circle-check"></i></span> We’ve received your receipt and it's being reviewed.</p>
          </div>
          <div class="submission-msg_donation_card">
            <div class="receipt-card d-md-block d-none m-auto">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <div class="receipt-card__title-wrap">
                    <span class="receipt-card__icon" aria-hidden="true">♡</span>
                    <h3 class="receipt-card__title">Donation to DonorsChoose</h3>
                  </div>
                  <p class="receipt-card__description">Once approved, your receipt unlocks funding for middle school
                    sports opportunities for kids in need</p>
                </div>
                <div class="flex-shrink-0 ms-3">
                  <img
                    src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon_doller3.png"
                    alt="$3 Icon" class="" />
                </div>
              </div>
            </div>
            <div class="receipt-card d-md-none d-block">
              <div class="receipt-card__top d-flex justify-content-between mb-2">
                <div class="receipt-card__left">
                  <img
                    src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon_doller3.png"
                    alt="$3 Icon" class="" />
                </div>
                <div class="receipt-card__right">
                  <img
                    src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon-heart.png"
                    alt="Heart Icon" class="" />
                </div>
              </div>
              <div class="receipt-card__content">
                <h3 class="receipt-card__title">Donation to DonorsChoose</h3>
                <p class="receipt-card__description">Once approved, your receipt unlocks funding for middle school
                  sports opportunities for kids in need</p>
              </div>
            </div>
          </div>
          <div class="submission-msg_desc mt-4">
            <p>We'll email you once your receipt is verified.</p>
            <p>Every receipt makes a difference. Thank you for being part of the mission.</p>
          </div>          
        </section>
      </div>
      <div id="upload-wrapper" v-if="upload_enabled">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <div class="text-block text-center position-relative">
            <h1 class="page-heading" v-html="$t('IPEwidget.UploadReceiptTitle')"></h1>
          </div>
          <p class="page-subheader text-center" v-html="$t('IPEwidget.UploadReceiptDesc')"></p>
          <div class="receipt-card d-md-block d-none m-auto">
            <div class="d-flex align-items-center">
              <div class="flex-grow-1">
                <div class="receipt-card__title-wrap">
                  <span class="receipt-card__icon" aria-hidden="true">♡</span>
                  <h3 class="receipt-card__title">One receipt = middle school sports funding </h3>
                </div>
                <p class="receipt-card__description">Every approved receipt funds a middle school sports program</p>
              </div>
              <div class="flex-shrink-0 ms-3">
                <img
                  src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon_doller3.png"
                  alt="$3 Icon" class="" />
              </div>
            </div>
          </div>
          <div class="receipt-card d-md-none d-block">
            <div class="receipt-card__top d-flex justify-content-between mb-2">
              <div class="receipt-card__left">
                <img
                  src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon_doller3.png"
                  alt="$3 Icon" class="" />
              </div>
              <div class="receipt-card__right">
                <img
                  src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon-heart.png"
                  alt="Heart Icon" class="" />
              </div>
            </div>
            <div class="receipt-card__content">
              <h3 class="receipt-card__title"> One receipt = middle school sports funding </h3>
              <p class="receipt-card__description">Every approved receipt funds a middle school sports program</p>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-md-4">
              <div class="card upload-instruction-card">
                <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon_LightbulbFilament.png" class="upload-instruction-icon" alt="Lightbulb Icon">
                <div class="card-body text-start">
                  <h5 class="card-title upload-instruction-title">Good lighting</h5>
                  <p class="card-text upload-instruction-text">Lay flat on a surface with bright, even light</p>  
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card upload-instruction-card">
                <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon_CornersOut.png" class="upload-instruction-icon" alt="Corners Out Icon">
                <div class="card-body text-start">
                  <h5 class="card-title upload-instruction-title">All four corners</h5>
                  <p class="card-text upload-instruction-text">Make sure the full receipt fits in frame</p>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="card upload-instruction-card">
                <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/images/icon_Receipt.png" class="upload-instruction-icon" alt="Receipt Icon">
                 <div class="card-body text-start">
                  <h5 class="card-title upload-instruction-title">Long receipt?</h5>
                  <p class="card-text upload-instruction-text">Take multiple photos and upload together</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div v-html="$t('IPEwidget.ImageUploadDesc1')"></div>
          <p class="d-none"> {{ $t('IPEwidget.ImageUploadDesc2') }}</p> -->
          <div class="mt-5">
            <snipp-upload :campaign-id="campaignId" include-upload-button="true"
              @snipp-upload-result="handleSnippUploadResult"
              custom-css="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/custom_overrides.css"
              :language="$t('Language')"></snipp-upload>
          </div>
          <section class="receipt-info">
            <div class="receipt-info__reminder">
              <p><span class="receipt-info__reminder-icon"><i class="fa-solid fa-circle-info"></i></span> Reminder:
              Receipts must be uploaded within 30 days of purchase.</p>
            </div>
            <p class="receipt-info__title text-start">Receipt must include</p>
            <div class="receipt-info__grid">

              <!-- Column 1 -->
              <ul class="receipt-info__list">
                <li>Store name</li>
                <li>Purchase date</li>
              </ul>

              <!-- Column 2 -->
              <ul class="receipt-info__list">
                <li>Eligible products</li>
                <li>Retailer name</li>
              </ul>

              <!-- Column 3 -->
              <ul class="receipt-info__list">
                <li>Item prices</li>
                <li>Total amount</li>
              </ul>

            </div>

            <!-- Footer Link -->
            <div class="receipt-info__footer">
              View <a href="http://snipp.us/!cuYS1"  target="_blank" class="receipt-info__link"> participating products</a>
            </div>

          </section>
        </div>
        <div id="upload-again" v-if="upload_enabled === 'upload_again'">
          <snipp-upload :campaign-id="campaignId" include-upload-again-button="true"
            @snipp-upload-result="handleSnippUploadResult"
            custom-css="https://snippcheck.blob.core.windows.net/files/WKKC_Frosted_Flakes_Mission_Tiger_2008858/custom_overrides.css"
            :language="$t('Language')"></snipp-upload>
          <p class="my-5 text-center">
            <a href="https://www.frostedflakes.us/mission-tiger/" target="_blank" class="btn-link">Visit Mission Tiger
              Homepage</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
    };
  },
  methods: {
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}

.color-red {
  color: #bf233a;
}
@media screen and (min-width: 800px) {
  #current-user-wrapper,
  #upload-wrapper {
    max-width: 90%;
    margin: 0 auto
  }
}



</style>
